export const HIVE_EVENT_LIST_VIEW = "/hive-events"
export const NEW_HIVE_EVENT_VIEW = HIVE_EVENT_LIST_VIEW + "/new"
export const HIVE_EVENT_VIEW = `${HIVE_EVENT_LIST_VIEW}/:hiveEventId`
